import { API } from './api';
import { queryify } from '../util/url-util';

export const disableAccess = (idp, token, password) => {
  const options = token && password ? { idp, token, password } : { idp };
  return API().post('sso/disable_access', options);
};

export const isSSO = (email, product) => API().get(`sso/is_sso${queryify({ email, product })}`);

export const sendPairingEmail = (token) => API().post('sso/send_pairing_email', { token });

export const sendUnpairingEmail = (email, idp, invite_code, redirect, product) =>
  API().post('sso/send_unpairing_email', { email, idp, invite_code, redirect, product });
